/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_6_TitleInputs */

const es_home_features_item_6_title = /** @type {(inputs: Home_Features_Item_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente IA Integrado`)
};

const en_home_features_item_6_title = /** @type {(inputs: Home_Features_Item_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrated AI Assistant`)
};

/**
* | output |
* | --- |
* | "Integrated AI Assistant" |
*
* @param {Home_Features_Item_6_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_6_title = /** @type {((inputs?: Home_Features_Item_6_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_6_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_6_title(inputs)
	return en_home_features_item_6_title(inputs)
});
export { home_features_item_6_title as "home.features.item_6_title" }